import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DoubleCounter from 'components/shared/counters/double/DoubleCounter';
import Emoji from 'components/shared/Emoji';
import routes from 'common/routes';

function SessionReminderCounters() {
  const { t } = useTranslation(['sessions']);
  const navigate = useNavigate();

  const tomorrowSessionsCounter = useSelector((state) => state.session.counters.tomorrow);
  const pendingToUpdateSessionsCounter = useSelector(
    (state) => state.session.counters.pendingToUpdate
  );

  return (
    <DoubleCounter
      emoji={<Emoji label={t('reminders', { ns: 'common' })} symbol="☝️" />}
      title={t('reminders', { ns: 'common' })}
      onClick={() => navigate(routes.listSession.path)}
      counters={[
        {
          title: t('sessionsTomorrow', { ns: 'sessions' }),
          counter: tomorrowSessionsCounter
        },
        {
          title: t('sessionsToReport', { ns: 'sessions' }),
          counter: pendingToUpdateSessionsCounter
        }
      ]}
    />
  );
}

export default SessionReminderCounters;
